import $ from 'jquery';

const ignoredEls = [
  'data-mobile-nav',
  'data-site-navigation',
];

function isIgnored(element) {
  // Disallow if element is a <script>
  if (element.tagName === 'SCRIPT') {
    return true;
  }

  // Allow if element has no attributes
  if (element.attributes.length === 0) {
    return false;
  }

  // Check if any attributes match to the ignore list
  return [].slice.call(element.attributes).some((attr) => {
    return ignoredEls.indexOf(attr.name) !== -1;
  });
}

export default function getHeaderOffset(header) {
  const headerEls = header.childNodes;
  const isSticky = header.querySelector('[data-site-header-sticky]');

  if (isSticky) {
    let offset = 0;
    for (let i = 0; i < headerEls.length; i++) {
      if (headerEls[i] instanceof HTMLElement && !isIgnored(headerEls[i])) {
        offset = offset + headerEls[i].getBoundingClientRect().height;
      }
    }

    if ($(header).hasClass('site-header-sticky--open') || window.pageYOffset === 0) {
      offset = offset + header.querySelector('[data-site-navigation]').getBoundingClientRect().height;
    }

    return offset;
  } else {
    const headerRect = header.getBoundingClientRect();
    return headerRect.bottom >= 0 ? headerRect.bottom : 0;
  }
}
